/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getProfessionnalInformationEtatiqueActions, {
    getProfessionnalInformationEtatiqueTypes,
} from '../../../redux/editique/getProfessionnalInformationEtatique'
import { Get } from '../../../serveur/axios'

function* getProfessionnalInformationEtatiqueSagas({ response }) {
    const {
        governorate,
        year,
        month,
        organization,
        yearSecondary,
        monthSecondary,
    } = response

    let url = '/editique/prof_etatique?'

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (month) {
        url = `${url}&month=${month}`
    }
    if (yearSecondary) {
        url = `${url}&yearSecondary=${yearSecondary}`
    }
    if (monthSecondary) {
        url = `${url}&monthSecondary=${monthSecondary}`
    }
    if (organization) {
        url = `${url}&organization=${organization}`
    }
    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getProfessionnalInformationEtatiqueActions.getProfessionnalInformationEtatiqueSuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getProfessionnalInformationEtatiqueActions.getProfessionnalInformationEtatiqueFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getProfessionnalInformationEtatiqueActions.getProfessionnalInformationEtatiqueFailure(
                error
            )
        )
    }
}

export function* getProfessionnalInformationEtatiqueSaga() {
    yield takeLatest(
        getProfessionnalInformationEtatiqueTypes.GET_PROFESSIONNAL_INFORMATION_ETATIQUE_REQUEST,
        getProfessionnalInformationEtatiqueSagas
    )
}
